import React from 'react';
import { Box, Typography, Divider, Stack, Chip } from '@mui/material';
import { sa } from '../superAdminUi';

// Shared building blocks so every wizard's summary rail reads the same: a sticky bordered
// card, small-icon fact rows, grouped subheadings and validation chips, on the Super Admin
// design tokens. Data logic stays in each rail; these only shape the presentation.

export function RailShell({ children }) {
  return (
    <Box
      sx={{
        p: 2.5,
        border: `1px solid ${sa.color.stroke}`,
        borderRadius: sa.radius.lg,
        bgcolor: sa.color.white,
        position: 'sticky',
        top: 16,
        fontFamily: sa.font.family,
      }}
    >
      <Typography
        sx={{ fontFamily: sa.font.family, fontWeight: sa.font.bold, fontSize: 16, color: sa.color.text, mb: 1.5 }}
      >
        Summary
      </Typography>
      {children}
    </Box>
  );
}

export function RailGroup({ title, children, first = false }) {
  return (
    <Box sx={{ mt: first ? 0 : 1.75 }}>
      {!first && <Divider sx={{ mb: 1.5, borderColor: sa.color.stroke }} />}
      <Typography
        sx={{
          fontFamily: sa.font.family,
          fontWeight: sa.font.bold,
          fontSize: 11,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          color: sa.color.textGray,
        }}
      >
        {title}
      </Typography>
      <Box sx={{ mt: 0.75 }}>{children}</Box>
    </Box>
  );
}

export function RailFact({ icon, label, value }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.75 }}>
      {icon && React.cloneElement(icon, { sx: { fontSize: 18, color: sa.color.teal } })}
      <Typography sx={{ fontFamily: sa.font.family, fontSize: 13, color: sa.color.textGray, flex: 1 }}>
        {label}
      </Typography>
      <Typography
        sx={{ fontFamily: sa.font.family, fontSize: 13, fontWeight: sa.font.semibold, color: sa.color.text, textAlign: 'right' }}
      >
        {value || '—'}
      </Typography>
    </Stack>
  );
}

export function RailChips({ children }) {
  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
      {children}
    </Stack>
  );
}

// The final-action gating hint shown at the foot of the rail.
export function RailGatingHint({ blocked, message }) {
  if (!blocked) return null;
  return (
    <Chip
      size="small"
      color="warning"
      variant="outlined"
      label={message}
      sx={{
        mt: 1.5,
        height: 'auto',
        fontFamily: sa.font.family,
        '& .MuiChip-label': { whiteSpace: 'normal', py: 0.5 },
      }}
    />
  );
}
